
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.86.645a.465.465 0 00-.298-.094.496.496 0 00-.374.165L4.125 7.778 1.768 5.677a.477.477 0 00-.33-.135.473.473 0 00-.335.135l-.305.287a.4.4 0 00-.137.311c0 .126.046.231.137.317l2.935 2.771a.732.732 0 00.79.124.624.624 0 00.236-.182L11.27 1.52a.444.444 0 00.106-.276.401.401 0 00-.186-.346l-.33-.253z","fill":"#000"}})])
          )
        }
      }
    